import { createSelector } from 'reselect'
import userHasDistrictProductSelector from 'redux/selectors/user/user_has_district_product_selector'

const schoolNameSelector = state => state.user.data.account.schoolName ? state.user.data.account.schoolName : ''

const myLibrarySchoolJoinConfirmSelector = createSelector(
	[schoolNameSelector, userHasDistrictProductSelector],
	(schoolName, hasDistrictProduct) => ({
		schoolName,
		hasDistrictProduct,
	})
)

export default myLibrarySchoolJoinConfirmSelector
